import classNames from "classnames"
import { FC } from "react"

// components
import { Footer } from "./Footer"
import FooterCopyright from "./FooterCopyright"
import { RegionSelector } from "../RegionSelector/RegionSelector"

// utils
import { events } from "../../utils/heap/tracking_events"

// styles
import {
  edsLMarTop4,
  edsGCell,
  edsLPadVert4,
  edsGlobalFooter__linkBullet
} from "../../theme/global.module.scss"
import {
  allRightsReserved,
  footerSectionBorder,
  footerBaseUl,
  footerBaseSection,
  footerBaseLinkSection
} from "./Footer.module.scss"

export type FooterNavCopy =
  Queries.HomepageDataQuery["contentfulFooterNavigation"]["FooterNavigationChildItems"]

type Props = {
  footerNavCopy: FooterNavCopy
}
export const FooterBase: FC<Props> = ({ footerNavCopy }) => {
  return (
    <>
      <div className={classNames(allRightsReserved, edsLMarTop4)}>
        <div>
          <div className={footerSectionBorder}></div>
        </div>
        <div
          className={classNames(footerBaseSection, edsGCell, edsLPadVert4)}
          id="footer-copyright"
        >
          <ul className={footerBaseUl}>
            <li>
              <FooterCopyright />
            </li>
            <li>
              <div className={footerBaseLinkSection}>
                {footerNavCopy?.map((footerBaseLink, index) => {
                  const isManageCookieLink =
                    footerBaseLink?.footerNavigationInternalTitle?.toLowerCase() ===
                    "link: manage cookie preferences"
                  const linkBullet =
                    index === footerNavCopy.length - 1
                      ? ""
                      : classNames(edsGlobalFooter__linkBullet)

                  return (
                    <a
                      key={`${footerBaseLink}__${index}`}
                      href={
                        isManageCookieLink
                          ? "#"
                          : footerBaseLink.footerNavigationUrl
                      }
                      target="_blank"
                      onClick={(e) => {
                        e.preventDefault()

                        events?.footerLinkClick(
                          `${footerBaseLink.displayText} - ${encodeURI(
                            footerBaseLink.footerNavigationUrl
                          )}`,
                          Footer?.name
                        )

                        if (typeof window !== "undefined") {
                          if (isManageCookieLink) {
                            window?.transcend?.showConsentManager?.({
                              viewState: "CompleteOptions"
                            })
                          } else {
                            window.open(
                              footerBaseLink?.footerNavigationUrl,
                              "_newtab"
                            )
                          }
                        }
                      }}
                      className={linkBullet}
                    >
                      {footerBaseLink?.displayText}
                    </a>
                  )
                })}
              </div>
            </li>
            <li>
              <div>
                <RegionSelector />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className={footerSectionBorder}></div>
    </>
  )
}
